import placeholderImage from '../../assets/tickets.svg'

const S3_PREFIX = String(process.env.REACT_APP_S3_PREFIX || '').replace(/\/?$/, '/')

const IMAGE_FIELDS = [
  'sThumbnail',
  'sThumbNail',
  'sEventThumbnail',
  'sVerticalThumbnail',
  'sHorizontalThumbnail',
  'sImage',
  'sBanner',
  'sPoster',
  'sFlyer',
  'sCoverImage',
  'sLogo',
  'sAppImage',
  'iThumbnail',
  'oThumbnail',
  'oImage',
  'oBanner',
  'aImage',
  'aImages'
]

function unwrapImage(value, depth = 0) {
  if (value == null || depth > 5) return ''
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return ''
    if ((trimmed.startsWith('{') || trimmed.startsWith('[')) && trimmed.length > 2) {
      try {
        return unwrapImage(JSON.parse(trimmed), depth + 1)
      } catch {
        return trimmed
      }
    }
    return trimmed
  }
  if (Array.isArray(value)) return unwrapImage(value[0], depth + 1)
  if (typeof value === 'object') {
    return unwrapImage(
      value.sUrl ||
        value.sURL ||
        value.sLocation ||
        value.sPath ||
        value.sKey ||
        value.sFile ||
        value.sImage ||
        value.sThumbnail ||
        value.url ||
        value.path ||
        value.location ||
        value.key,
      depth + 1
    )
  }
  return ''
}

function pickEventImageRaw(event) {
  if (!event || typeof event !== 'object') return ''
  for (const field of IMAGE_FIELDS) {
    const raw = unwrapImage(event[field])
    if (raw) return raw
  }
  if (event.oEvent && typeof event.oEvent === 'object') {
    const nested = pickEventImageRaw(event.oEvent)
    if (nested) return nested
  }
  for (const [key, value] of Object.entries(event)) {
    if (/thumb|image|banner|poster|flyer|cover|photo/i.test(key)) {
      const raw = unwrapImage(value)
      if (raw) return raw
    }
  }
  return ''
}

function toAbsoluteUrl(raw) {
  if (!raw) return ''
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) return raw
  if (raw.startsWith('//')) return `https:${raw}`
  if (!S3_PREFIX) return raw
  return `${S3_PREFIX}${raw.replace(/^\//, '')}`
}

export function getImageUrl(imageUrl) {
  return toAbsoluteUrl(unwrapImage(imageUrl)) || placeholderImage
}

export function getEventImageUrl(event) {
  return toAbsoluteUrl(pickEventImageRaw(event)) || placeholderImage
}

export { placeholderImage }
